<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">{{ 'results.details.title' | translate }}</p>
    <i class="fa-light fa-xmark ms-auto cursor-pointer" (click)="dismiss()"></i>
  </div>
  <div class="modal-body">
    @if (result()) {
      <div class="d-flex justify-content-between align-items-end mb-1">
        <p class="caption mb-1">
          {{ 'results.details.baseInfo' | translate }}
        </p>
        <div class="text-end col-3">
          <button
            class="icon-btn mb-1 me-2"
            ngbTooltip="Reports overview"
            triggers="hover"
            Placement="left"
            type="submit"
            [class.icon-btn-sm]="!coreUtilsService.tabletMode()"
            [class.icon-btn-lg]="coreUtilsService.tabletMode()"
            [disabled]="!result().reportIds.length"
            (click)="resultsUtils.openReportsOverview(result().id)"
          >
            <i class="fa-light fa-file-invoice fa-fw"></i>
          </button>

          <button
            *appRequirePermission="'serviceData.details'"
            class="icon-btn mb-1 me-2"
            ngbTooltip="Service data"
            triggers="hover"
            Placement="left"
            type="submit"
            [class.icon-btn-sm]="!coreUtilsService.tabletMode()"
            [class.icon-btn-lg]="coreUtilsService.tabletMode()"
            (click)="serviceDataUtils.openServiceDataByKitId(result().kitId)"
          >
            <i class="fa-light fa-file-lines fa-fw"></i>
          </button>

          <button
            *appRequirePermission="'followUps'"
            class="icon-btn mb-1 me-2"
            ngbTooltip="Follow ups"
            triggers="hover"
            Placement="left"
            type="submit"
            [class.icon-btn-sm]="!coreUtilsService.tabletMode()"
            [class.icon-btn-lg]="coreUtilsService.tabletMode()"
            [disabled]="!result().followUpIds.length"
            (click)="
              followUpsUtils.openFollowUpsListDialog(result().followUpIds)
            "
          >
            <i class="fa-light fa-square-exclamation fa-fw"></i>
          </button>
        </div>
      </div>

      <hr class="mt-0" />
      <div class="row mb-2 mb-sm-0">
        <div class="col-12 col-sm-5 mb-sm-2">
          <label class="label">{{ 'results.details.kitId' | translate }}</label>
        </div>
        <div class="col-12 col-sm-7">{{ result().kitId }}</div>
      </div>
      <div class="row mb-2 mb-sm-0">
        <div class="col-12 col-sm-5 mb-sm-2">
          <label class="label">{{
            'results.details.status' | translate
          }}</label>
        </div>
        <div class="col-12 col-sm-7">{{ result().status }}</div>
      </div>
      @if (importerInfo()) {
        <div class="row mb-2 mb-sm-0">
          <div class="col-12 col-sm-5 mb-sm-2">
            <label class="label">{{
              'results.details.importType' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-7">{{ importerInfo().type.type }}</div>
        </div>
        <div class="row mb-2 mb-sm-0">
          <div class="col-12 col-sm-5 mb-sm-2">
            <label class="label">{{
              'results.details.importVersion' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-7">{{ importerInfo().version.label }}</div>
        </div>
      }
      <div class="row mb-2 mb-sm-0">
        <div class="col-12 col-sm-5 mb-sm-2">
          <label class="label">{{
            'results.details.signee' | translate
          }}</label>
        </div>
        <div class="col-12 col-sm-7">{{ signee().name }}</div>
      </div>
      <div class="row mb-2 mb-sm-0">
        <div class="col-12 col-sm-5 mb-sm-2">
          <label class="label">{{
            'results.details.generated' | translate
          }}</label>
        </div>
        <div class="col-12 col-sm-7">{{ result().generated | date }}</div>
      </div>
      <div class="row mb-2 mb-sm-0">
        <div class="col-12 col-sm-5 mb-sm-2">
          <label class="label">{{
            'results.details.importedBy' | translate
          }}</label>
        </div>
        <div class="col-12 col-sm-7">
          <app-user-display [userId]="result().generatedBy" />
        </div>
      </div>
      @if (result().failed) {
        <div class="row mb-2 mb-sm-0">
          <div class="col-12 col-sm-5 mb-sm-2">
            <label class="label">{{
              'results.details.failed' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-7">{{ result().failed | date }}</div>
        </div>
        <div class="row mb-2 mb-sm-0">
          <div class="col-12 col-sm-5 mb-sm-2">
            <label class="label">{{
              'results.details.failedReason' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-7">{{ result().failedReason }}</div>
        </div>
      }
      @if (result().archived) {
        <div class="row mb-2 mb-sm-0">
          <div class="col-12 col-sm-5 mb-sm-2">
            <label class="label">{{
              'results.details.archived' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-7">{{ result().archived | date }}</div>
        </div>
        <div class="row mb-2 mb-sm-0">
          <div class="col-12 col-sm-5 mb-sm-2">
            <label class="label">{{
              'results.details.archivedReason' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-7">{{ result().archivedReason }}</div>
        </div>
      }
      <p class="caption mb-1">
        {{ 'results.details.resultInfo' | translate }}
      </p>
      <hr class="mt-0" />
      @for (key of Object.keys(result().data); track key) {
        <div class="row mb-2 mb-sm-0">
          <div class="col-12 col-sm-5 mb-sm-2">
            <label class="label">{{ key }}</label>
          </div>
          <div class="col-12 col-sm-7">{{ result().data[key] }}</div>
        </div>
      }
    } @else {
      <div class="py-4 loading"></div>
    }
  </div>
  <div class="modal-footer">
    <button
      ngbAutoFocus
      type="button"
      class="btn btn-clear"
      (click)="dismiss()"
    >
      {{ 'common.buttons.btnClose' | translate }}
    </button>
  </div>
</div>
